module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/testingRightTopBg-ac95d7811c93715c22b1ab9cb4b4a4e0.png";